import React, { useState, useEffect, Link } from "react";
import axios from "axios";
import { Cookies } from "../../../index.js";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { alert_error, alert_success } from "../../../AppContext";
import AdSense from 'react-adsense';
function Ordergoogle() {

    const [codeSnippet, setcodeSnippetd] = useState(`<div id="hustmedia"></div>
<script src='https://hust.media/api/website/main.js?v=4&chedo=1'></script>`);
    const [isDisabled, setIsDisabled] = useState(true);
    const [username, setusername] = useState("");
    const [social, setSocial] = useState("");
    const [chietkhau, setchietkhau] = useState("");
    const [damoshop, setdamoshop] = useState(Cookies.get("damoshop"));
    const [nutorder, setnutorder] = useState("✔️ Click to Confirm");
    const [nutxuly, setnutxuly] = useState(0);
    const [inputlienket, setinputlienket] = useState("");
    const [chedo, setchedo] = useState("");
    const [amount, setamount] = useState("");
    const [money, setmoney] = useState(null);
    const [comments, setcomments] = useState("");
    const [commentsok, setcommentsok] = useState("");
    const [isOpen, setIsOpen] = useState(true);
    const [isOpen2, setIsOpen2] = useState(true);
    const [service, setservice] = useState(true);
    const [service2, setservice2] = useState(true);
    const navigate = useNavigate();
    const handleTextareaChange = (event) => {
        const text = event.target.value;
        const formattedText = text.replace(/\n/g, '<br>');
        setcomments(formattedText);
        setcommentsok(text);
    };

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    const handleCommentsChange = () => {
        const amountok = commentsok.split("\n").length;
        setamount(amountok);
        tinhgia(amountok);
    };
    useEffect(() => {
        handleCommentsChange();
    }, [commentsok]);
    const [options, setoptions] = useState([
        {
            id: "",
            stt: "",
            name: "Please wait a moment 😊 đang tải dịch vụ",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);
    const [options2, setoptions2] = useState([
        {
            id: "",
            stt: "",
            name: "Chọn 1 dịch vụ của bạn",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);
    const [options2s, setOptions2s] = useState([
        { label: 'Level User 1 - 40s - 150xu', value: '40', money: '150' },
        { label: 'Level User 2 - 70s - 200xu', value: '70', money: '200' },
        { label: 'Level User 3 - 100s - 250xu', value: '100', money: '250' },
    ]);
    const handleOptionChange2 = (event) => {
        const selectedOption = event.target.value;

        setchedo(selectedOption);
        console.log(selectedOption);
    };
    const handleOptionChange = (event) => {
        setIsOpen(false);
        const selectedOption = event.value;
        const selectedOptionok = options.find(
            (option) => option.id == selectedOption
        );
        console.log(selectedOptionok);
        setservice(selectedOptionok);
        if (selectedOptionok.category == 'banner') {
            navigate('/shop/ads/adsprofiles');
        }
        else if (selectedOptionok.category == 'search') {
            setcodeSnippetd(`<div id="hustmedia"></div>
<script src='https://hust.media/api/website/main.js?v=4&chedo=2'></script>`);
        }
        else if (selectedOptionok.category == 'redirect') {
            setcodeSnippetd(`<div id="hustmedia"></div>
<script src='https://hust.media/api/website/main.js?v=4&chedo=1'></script>`);
        }
        //   setcontent(selectedOptionok.category);
        // axios
        //   .post("https://hust.media/getservice/service5.php", {
        //     chedo: "service",
        //     category: selectedOptionok.option,
        //   })
        //   .then((response) => laydichvu(response))
        //   .catch((error) => console.log(error));
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    };
    function laydichvu(response) {
        const arr1 = [
            {
                id: "",
                stt: "",
                name: "Chọn 1 dịch vụ mà bạn cung cấp dịch vụ",
                money: "",
                status: "show",
                content: "",
                servicecode: "",
            },
        ];

        const arr2 = response.data;

        setoptions2(arr1.concat(arr2));
    }
    //   function gopdulieu(response) {
    //     const arr1 = [
    //       {
    //         id: "",
    //         stt: "",
    //         name: "Chọn 1 thể loại mà bạn cung cấp dịch vụ",
    //         money: "",
    //         status: "show",
    //         content: "",
    //         servicecode: "",
    //       },
    //     ];

    //     const arr2 = response.data;

    //     setoptions(arr1.concat(arr2));
    //   }
    function tinhgia2(amountok, rate) {
        const giagiamok = rate * amountok * chietkhau / 100;
        const giaok = rate * amountok - giagiamok;
        setmoney(giaok);
    }
    function tinhgia(amountok) {
        console.log(service2.money);
        if (service.category == 'search') {
            tinhgia2(amountok, service2.money);
        }
        else {
            tinhgia2(amountok, service.money);
        }

    }
    function laydulieu() {
        const apikey = Cookies.get("apikey");
        axios
            .post("https://hust.media/getservice/service.php", {
                category: "googleplay",
            })
            .then((response) => nhadichvu(response))
            .catch((error) => alert_error(error));

        axios
            .post("https://hust.media/api/wallet/laychietkhau.php?apikey=" + apikey)
            .then((response) => setchietkhau(response.data))
            .catch((error) => console.log(error));
    }
    function nhadichvu(response) {
        setoptions(response.data);
        setIsDisabled(false)
    };
    function testFunction(response) {
        const info = response.data;
        const orderok = info.order;
        const error = info.error;
        setnutorder("đặt tiếp luôn nào");
        setnutxuly(0);
        if (error) {
            alert_error(info.error);
        } else if (orderok) {
            alert_success('Thankiuu Bạn là người thứ ' + orderok + ' ủng hộ Hust Media');
        }
        else {
            alert_error('Lỗi không xác định vui lòng liên hệ admin');
        }
        if (info.redirect != null && info.redirect != "") {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    }
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get("apikey");
        const national_market = Cookies.get("national_market");
        event.preventDefault();

        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        if (!inputlienket) {
            alert("Please điền đầy đủ thông tin");
            setnutxuly(0);
            setnutorder("điền đủ thông tin");
            return;
        }
        axios
            .post("https://hust.media/api/v3", {
                action: 'add',
                comments: comments,
                key: apikey,
                link: inputlienket,
                username: username,
                quantity: amount,
                national_market: national_market,
                service: service.id,
            })
            .then((response) => testFunction(response))
            .catch((error) => loimatroi(error));
    }
    const loimatroi = (error) => {
        alert_error(error);
        setnutorder("Thử lại xem");
        setnutxuly(0)
    };
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleBlur2 = () => {
        setIsOpen2(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };
    const handleChange2 = (selectedOption2) => {
        setusername(selectedOption2.value);
        setIsOpen2(false);
        setservice2(selectedOption2);
        tinhgia2(amount, selectedOption2.money);
    };
    function saochep(value) {
        alert_success("Đã sao chép");
        window.saochepnative(value);
    }

    useEffect(() => {
        // Thực hiện các hành động liên quan đến giá trị đã chọn tại đây
    }, [social]);
    useEffect(() => {
        laydulieu();
        setamount('');
    }, []);
    const platforms = [
        { name: 'TikTok', value: 'tiktok' },
        { name: 'Facebook', value: 'facebook' },
        { name: 'YouTube', value: 'youtube' },
        { name: 'Instagram', value: 'insta' }
    ];

    const handleSelection = (platform) => {
        setcomments(platform);
    };
    return (
        <>
            <div className="mt-1 mx-2">
                <div className="max-h-16">
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="1627514116"
                            style={{ display: 'block' }}
                            format='horizontal'
                            responsive='false'
                        /></div>
                </div>
                <form className="mt-1 add-form">
                    <div className="form-control">
                        <label className="text-sm">Chọn dịch vụ của bạn</label>
                        <Select
                            classNamePrefix="Chọn 1 lựa chọn"
                            onFocus={handleFocus}
                            options={options.map((option) => ({
                                value: option.id,
                                label: option.name + ' ' + option.money + ' Coins',
                            }))}
                            menuIsOpen={isOpen}
                            isDisabled={isDisabled} // Khi isDisabled là true, người dùng không thể chọn
                            onBlur={handleBlur}
                            onMenuOpen={handleMenuOpen}
                            onChange={handleOptionChange} // Use selectedOption.value to get the selected value
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                        />
                        {/* <label>Chọn dịch vụ mà bạn cung cấp</label>
                        <br />
                        <select
                        id="countries2"
                        className="selectpicker sp2 form-control"
                        onChange={handleOptionChange2}
                        value={chedo}
                        >
                        {options2.map((option) => (
                            <option key={option.id} value={option.id}>
                            {option.name}
                            </option>
                        ))}
                        </select> */}
                        <label className="text-sm">Link,id app, post, video, username cần thực thi</label>
                        <br />
                        <div className="input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                url
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Copy và điền liên kết ở đây"
                                aria-label="inputlienket"
                                value={inputlienket}
                                name="inputlienket"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => setinputlienket(e.target.value)}
                            />
                        </div>
                        {service.content && (
                            <>
                                <div className="text-sm" dangerouslySetInnerHTML={{ __html: service.content }}></div>
                            </>
                        )}
                        {service && service.type && service.type.includes("comment") ? (
                            <>
                                <div className="p-1">
                                    <div className="mt-0 my-0 block font-medium text-sm mx-auto">
                                        Số lượt tải và đánh giá tăng là : {amount}
                                    </div>
                                    <textarea
                                        className="w-full h-40 border mb-0 border-gray-300 rounded p-2 resize-none"
                                        placeholder="Nhập đánh giá..."
                                        value={commentsok}
                                        onChange={handleTextareaChange}
                                    />
                                    <div className="text-xs mt-[-1px]">
                                        {" "}
                                        Tối thiểu {service.minorder} &emsp; Tối đa {service.maxorder}
                                    </div>
                                </div>
                            </>
                        ) : service.id && (
                            <>
                                <label className="mt-0 mb-0 flex justify-center items-center">Số lượng tăng</label>
                                <div className="input-group flex-nowrap">
                                    <input
                                        onChange={(e) => {
                                            setamount(e.target.value);
                                            tinhgia(e.target.value);
                                        }}
                                        value={amount}
                                        type="text"
                                        className="form-control mb-0"
                                        placeholder="Nhập số lượng mong muốn"
                                        aria-label="inputcaption"
                                        name="inputcaption"
                                        aria-describedby="addon-wrapping"
                                    ></input>
                                </div>
                                <div className="text-xs mt-[-2px] ">
                                    Tối thiểu {service.minorder} &emsp; Tối đa {service.maxorder}
                                </div>
                                {service && service.type && service.type.includes("search") && (
                                    <>

                                        <div className="input-group flex-nowrap">
                                            <input
                                                onChange={(e) => {
                                                    setcomments(e.target.value);
                                                }}
                                                value={comments}
                                                type="text"
                                                className="form-control mb-0"
                                                placeholder="Từ khóa cần seo"
                                                aria-label="inputcaption"
                                                name="inputcaption"
                                                aria-describedby="addon-wrapping"
                                            ></input>   </div>
                                        <label className="text-sm">Chọn level của bạn</label>
                                        <Select
                                            className="mb-1"
                                            classNamePrefix="Chọn 1 lựa chọn"
                                            onFocus={handleFocus2}
                                            options={options2s}
                                            menuIsOpen={isOpen2}
                                            onBlur={handleBlur2}
                                            onMenuOpen={handleMenuOpen2}
                                            onChange={handleChange2} // Use selectedOption.value to get the selected value
                                            isDisabled={false}
                                            isLoading={false}
                                            isClearable={true}
                                            isRtl={false}
                                            isSearchable={false}
                                        />
                                    </>

                                )}
                            </>
                        )}
                        {service && service.type && service.type.includes("website") && (
                            <>
                                <div className="mt-2 mb-2 bg-gray-900 px-2 py-1 rounded-lg relative">
                                    <div className="flex items-center justify-between ">
                                        <div className="text-sm mb-1 text-gray-400 ">Đoạn code gắn vào Footer web đích</div>
                                        <div className="flex space-x-1">
                                            <button
                                                type="button"
                                                className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                                                onClick={() => saochep(codeSnippet)}
                                            >
                                                Copy
                                            </button>
                                            <a href="https://t.me/hustmedia" target="_blank" className="ml-auto">
                                                <button
                                                    type="button"
                                                    className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                                                >
                                                    Support
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                    <pre className="whitespace-pre-wrap text-gray-300">{codeSnippet}</pre>
                                </div>

                            </>
                        )}
                        {service && service.type && service.type.includes("googlemaps") && (
                            <>
                                <label className="mt-0 mb-0 flex justify-center items-center">Mô tả dịch vụ maps bạn cung cấp</label>
                                <div className="input-group flex-nowrap">
                                    <input
                                        onChange={(e) => {
                                            setcomments(e.target.value);
                                        }}
                                        value={comments}
                                        type="text"
                                        className="form-control mb-0"
                                        placeholder="Cửa hàng bán điện thoại iphone ở Hà Nội"
                                        aria-label="inputcaption"
                                        name="inputcaption"
                                        aria-describedby="addon-wrapping"
                                    ></input>
                                </div>
                                <div className="text-sm mt-[-1px] ">
                                    thành viên app sẽ dựa theo "mô tả dịch vụ Maps bạn cung cấp" để tự nghĩ nội dung review phù hợp.
                                </div>

                            </>
                        )}
                        {(service && service.type && service.type.includes("zalo_mem")) && (
                            <>
                                <label className="mt-0 mb-0 flex justify-center items-center">
                                    Tên nhóm zalo
                                </label>
                                <div className="input-group flex-nowrap">
                                    <input
                                        onChange={(e) => {
                                            setcomments(e.target.value);
                                        }}
                                        value={comments}
                                        type="text"
                                        className="form-control mb-0"
                                        placeholder="ví dụ: Box anti Hust Media"
                                        aria-label="inputcaption"
                                        name="inputcaption"
                                        aria-describedby="addon-wrapping"
                                    ></input>
                                </div>
                                <div className="text-sm mt-[-1px] ">
                                    Nếu thay tên nhóm khi đang chạy sẽ không hoàn Coins
                                </div>
                            </>
                        )}
                        {service && service.type && service.type.includes("report_social") && (
                            <>
                                <div className="mx-auto flex flex-col items-center justify-center">
                                    <h2 className="text-xl text-gray-800 mb-1">Chọn một nền tảng:</h2>
                                    <div className="grid grid-cols-2 gap-2">
                                        {platforms.map((platform) => (
                                            <div
                                                key={platform.value}
                                                className={`py-2 px-4 rounded ${comments === platform.value ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'}`}
                                                onClick={() => handleSelection(platform.value)}
                                            >
                                                {platform.name}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mt-0">
                                        <p className="text-gray-600">Đã chọn: {comments}</p>
                                    </div>
                                </div>
                            </>
                        )}
                        <button
                            disabled={nutxuly}
                            onClick={handleSubmit}
                            className="mt-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white"
                        >
                            <div className="flex items-center justify-between flex-1">
                                {nutxuly == 1 && (
                                    <div className="spinner-border" role="status"></div>
                                )}

                                <span className="text-lg font-medium text-white">
                                    {nutorder}{" "}
                                </span>
                                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                            </div>
                        </button>
                        <div className="relative mt-0 p-2 rounded-md border-2 border-pink-500 bg-white">
                            {money ? (
                                <div className="text-xs lg:text-base">
                                    🌟 Tổng : {money} Coins
                                </div>) : (<></>)}
                            <div className="text-xs lg:text-base">
                                🏷️ Số lượng tăng: {amount}
                            </div>
                            <div className="text-xs lg:text-base">
                                🎁 Chiết khấu: {chietkhau}%
                                <span className="ml-1">&#10132;</span>
                                <span className="text-gray-600">
                                    Tặng 1 ưu đãi miễn phí cho lần tiếp theo
                                </span>
                            </div>
                            <div className="absolute top-0 left-0 w-full h-full rounded-md border-2 border-pink-500 opacity-0 transition-opacity duration-300 hover:opacity-100"></div>
                        </div>
                    </div>
                </form>

            </div>

            <br></br>
        </>
    );
}

export default Ordergoogle;
